import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LoginForm} from '../login-form';
import {Alert} from '../../../utils/alert';
import {ValidatorUtils} from '../../../utils/validator-utils';
import {UserInfoStorageService} from '../../../services/auth/user-info-storage.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CrystalClearFrontUrl} from '../../../shared/pages/crystal-clear-front-url';
import {HttpErrorInterceptor} from '../../../services/interceptor/http-error.interceptor';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'app-login-credentials',
  templateUrl: './login-credentials.component.html',
  styleUrls: ['./login-credentials.component.scss']
})
export class LoginCredentialsComponent {

  @Input() lastUrl: string = CrystalClearFrontUrl.HOME.path;
  @Output() forgotPassword = new EventEmitter<void>();
  @Output() mustChangePwd = new EventEmitter<void>();

  loginForm = LoginForm.getForm();
  readonly LoginForm = LoginForm;
  readonly ValidatorUtils = ValidatorUtils;
  readonly Alert = Alert;

  displayErrorDynamic = false;
  loading = false;
  alert: Alert | undefined;

  constructor(
    private authService: UserInfoStorageService,
    private router: Router,
    public translateService: TranslateService,
    private messageService: MessageService
  ) {}

  logIn() {
    if (this.loading) {
      return;
    }
    this.displayErrorDynamic = true;
    this.alert = undefined;

    if (this.loginForm.valid) {
      this.loading = true;
      localStorage.setItem('username', LoginForm.getValue(this.loginForm).login);
      localStorage.setItem('password', LoginForm.getValue(this.loginForm).password);

      this.authService.login(LoginForm.getValue(this.loginForm)).subscribe(
        apiValidation => {
          if (apiValidation.success) {
            const target = this.lastUrl && this.lastUrl !== CrystalClearFrontUrl.LOGIN.path
              ? this.lastUrl
              : CrystalClearFrontUrl.HOME.path;
            this.router.navigateByUrl(target).then(() => {
              localStorage.removeItem('username');
              localStorage.removeItem('password');
            });
          } else if (HttpErrorInterceptor.Type.USER_HAVE_TO_CHANGE_PASSWORD.toString() === apiValidation.message) {
            this.displayErrorDynamic = false;
            this.mustChangePwd.emit();
          } else {
            const status = this.extractReferenceCode(apiValidation.message) ? Alert.Status.ERROR : Alert.Status.WARN;
            this.alert = new Alert(status, undefined, {key: apiValidation.message, params: {}});
          }
          this.loading = false;
        },
        () => this.loading = false
      );
    } else {
      this.alert = ValidatorUtils.getFormError(this.loginForm, LoginForm.FIELDS._NAME)
        .getAlert(Alert.Status.ERROR, this.translateService);
    }
  }

  getError(): string | undefined {
    let error: string | undefined;

    if (this.displayErrorDynamic && this.loginForm.invalid && (this.loginForm.dirty || this.loginForm.touched)) {
      error = ValidatorUtils.getFormError(this.loginForm, LoginForm.FIELDS._NAME).getI18n(this.translateService);
    }
    if (error) {
      this.alert = undefined;
    }
    if (!error && this.alert) {
      error = this.translateService.instant(this.alert.detail.key, this.alert.detail.params);
    }
    return error;
  }

  extractReferenceCode(text: string | undefined): string | null {
    if (!text) {
      return null;
    }
    const match = /reference code:\s*([A-Za-z0-9]+)/i.exec(text);
    return match ? match[1] : null;
  }

  copiedToClipboard() {
    this.messageService.add({
      severity: 'success',
      icon: 'fas fa-clipboard-check',
      detail: 'Copied to Clipboard!',
      life: 1000
    });
  }
}
